import type { DataManagementService } from "../services/dataManagement";
import type { AccHub, AccProject } from "../services/dataManagement/types";

/** Prefer the folder the user is browsing; otherwise ACC "Project Files" or first top folder. */
export async function resolveUploadFolderId(
  dm: DataManagementService,
  hub: AccHub,
  project: AccProject,
  activeFolderId: string | null
): Promise<string> {
  if (activeFolderId?.trim()) return activeFolderId;

  const top = await dm.getProjectTopFolders(hub.id, project.id, hub.region);
  const folders = top.filter(f => f.objectType === "folders");
  const projectFiles = folders.find(f => /project files/i.test(f.name));
  const target = projectFiles ?? folders[0];
  if (!target) {
    throw new Error("No ACC folder found to upload into.");
  }
  return target.id;
}
